export default __webpack_public_path__ + "static/media/large.2d72aaee.jpg";